<div
    #chartElementRef
    class="agpr-top-entities-container"
    [style.height]="height ? height + 'px' : null"
>
    @if (displayElement?.chartHeaderSettings.title || metricSelectable) {
        <h4 class="agpr-top-entities-heading">
            @if (metricSelectable) {
                @if(sentimentType) {
                    {{ 'Monitor.MAD.topEntities.title.' + entityType  + sentimentType + '.by' | localize }}
                } @else {
                    {{ 'Monitor.MAD.topEntities.title.' + entityType + '.by' | localize }}
                }

                <agpr-dropdown
                    [id]="id + '_topEntitiesDropdown'"
                    class="agpr-top-entities-heading-metric"
                    [style]="dropdownTypes.borderless"
                    [agprStyle]="agprComponentStyle.social"
                    [options]="options"
                    ariaLabel="Social.intelligence.charts.wordCloud.dropdownLabel"
                    [(ngModel)]="selectedMetric"
                    (ngModelChange)="onMetricChange()"
                    panelStyleClass="agpr-dropdown-panelSocial"
                ></agpr-dropdown>
            } @else {
                <span>{{ displayElement?.title || ('Monitor.MAD.topEntities.title.' + entityType | localize) }}</span>
            }
        </h4>
    }
    @if (displayElement?.chartHeaderSettings?.dateRange || displayElement?.chartHeaderSettings?.sourceLink) {
        <div class="agpr-chartBlockMetadata-subtitleGroup">
            @if (displayElement?.chartHeaderSettings?.dateRange) {
                <label
                    class="agpr-chartBlockMetadata-dateRange"
                    [id]="id + '_topEntitiesChart_dateRange'"
                    [pTooltip]="displayElement?.dateRangeLabel"
                    tooltipPosition="bottom"
                    tabindex="0"
                >
                    {{ displayElement?.dateRangeLabel }}
                </label>
            }
            @if (displayElement?.chartHeaderSettings?.sourceLink) {
                @if (displayElement?.chartHeaderSettings?.displaySourceAsLink) {
                    <a
                        class="agpr-chartBlockMetadata-source agpr-chartBlockMetadata-sourceLink"
                        [ngClass]="{'noDate': !displayElement?.chartHeaderSettings?.dateRange}"
                        target="_blank"
                        [routerLink]="sourceRouterLink"
                        [queryParams]="sourceRouterLinkQueryParams"
                        [pTooltip]="series ? series.label : ''"
                        tooltipPosition="bottom"
                        [attr.tabindex]="(series && series.label) ? '0' : '-1'"
                    >
                        {{ series?.label }}
                    </a>
                } @else {
                    <span
                        class="agpr-chartBlockMetadata-source"
                        [ngClass]="{'noDate': !displayElement?.chartHeaderSettings?.dateRange}"
                        [pTooltip]="series && series[0] ? series[0].label : ''"
                        tooltipPosition="bottom"
                        [attr.tabindex]="(series && series[0] && series[0].label) ? '0' : '-1'"
                    >
                        {{ series?.label }}
                    </span>
                }
            }
        </div>
    }
    <div
        class="agpr-top-entities-chartContainer"
        [style.height]="height ? (height - headerHeight) + 'px' : null"
    >
        <div
            class="agpr-top-entities-card agpr-top-entities-chart agpr-block-content agpr-top-entities-lhp"
            [ngClass]="{'agpr-top-entities-chart-noData': noData}"
            [style.height]="height ? (height - headerHeight) + 'px' : null"
        >
            <agpr-reports-chart
                [ngClass]="{ 'agpr-top-entities-card--noData': noData }"
                [chart]="chart"
                [disableViewMentionLink]="disableViewMentionLink"
                (noContent)="updateNoData($event)"
            ></agpr-reports-chart>
            @if (noData) {
                <agpr-message
                    class="agpr-top-entities-noContentMessage"
                    [severity]="messageSeverities.noContent"
                >
                    {{ 'Monitor.MAD.chart.noContentLabel' | localize }}
                </agpr-message>
            }
        </div>
        <div class="agpr-top-entities-separator"></div>
        <div
            role="region"
            class="agpr-top-entities-card agpr-top-entities-rhp"
            [style.height]="height ? (height - headerHeight) + 'px' : null"
            [style.maxHeight]="height ? (height - headerHeight) + 'px' : null"
            [agprLoading]="profileLoading"
        >
            @if (selectedEntity) {
                @if (bigProfileImage) {
                    <div class="agpr-top-entities-miniProfile">
                        <ng-container *ngTemplateOutlet="thumbnail"></ng-container>
                        <div class="agpr-top-entities-miniProfile-info">
                            <div class="agpr-top-entities-miniProfile-title">
                                <ng-container *ngTemplateOutlet="entityName"></ng-container>
                            </div>
                            <ng-container *ngTemplateOutlet="metadata"></ng-container>
                        </div>
                    </div>
                } @else {
                    <div class="agpr-top-entities-miniProfile agpr-top-entities-miniProfile-title">
                        <ng-container *ngTemplateOutlet="thumbnail"></ng-container>
                        <ng-container *ngTemplateOutlet="entityName"></ng-container>
                    </div>
                    <div class="agpr-top-entities-miniProfile-maxWidth">
                        <ng-container *ngTemplateOutlet="metadata"></ng-container>
                    </div>
                }
                <ng-template #thumbnail>
                    <div class="agpr-top-entities-miniProfile-thumbnail">
                        <img
                            class="agpr-top-entities-miniProfile-thumbnail-img"
                            [agprImageSrc]="selectedEntity?.avatarUrl | twitterAvatarSize:twitterAvatarSizes.original"
                            [agprDefaultImage]="imageDefault[selectedEntity?.entityType]"
                            alt=""
                        />
                        @if (selectedEntity?.entityType !== entityTypes.OUTLET && selectedEmployment?.outlet) {
                            <ng-container>
                                <img
                                    class="agpr-top-entities-miniProfile-thumbnail-img agpr-top-entities-miniProfile-thumbnail-img--outlet"
                                    [agprImageSrc]="selectedEmployment.outlet.avatarUrl | twitterAvatarSize:twitterAvatarSizes.original"
                                    [agprDefaultImage]="imageDefault.SMALL_OUTLET"
                                    alt=""
                                />
                            </ng-container>
                        }
                    </div>
                </ng-template>
                <ng-template #entityName>
                    @if (selectedEntity?.entityType === entityTypes.OUTLET && outletEntity) {
                        <span class="agpr-top-entities-miniProfile-name">
                            {{ selectedEntity.name }}
                        </span>
                    }
                    @if (selectedEntity?.entityType === entityTypes.CONTACT && contactEntity) {
                        <span class="agpr-top-entities-miniProfile-name">
                            {{ contactEntity.firstName }} {{ contactEntity.lastName }}
                        </span>
                    }
                </ng-template>
                <ng-template #metadata>
                    @if (selectedEntity?.entityType === entityTypes.OUTLET && outletEntity) {
                        @if (outletEntity.mediaTypes?.length > 0) {
                            <div class="agpr-top-entities-miniProfile-infoCard">
                                <agpr-meta-data
                                    [id]="id"
                                    [type]="attributeTypesEnum.simpleList"
                                    [icon]="'fa-solid fa-globe'"
                                    [value]="mediaTypeDisplay"
                                    [tooltip]="mediaTypeDisplay"
                                    [isMultiline]="true"
                                ></agpr-meta-data>
                            </div>
                        }
                        @if (outletEntity?.geography?.displayString) {
                            <div class="agpr-top-entities-miniProfile-infoCard agpr-top-entities-miniProfile-infoCard-geo">
                                <agpr-meta-data
                                    [id]="id"
                                    class="agpr-top-entities-miniProfile-infoCard-geo"
                                    [icon]="'fa-regular fa-location-dot'"
                                    [value]="outletEntity.geography.displayString"
                                    [tooltip]="outletEntity.geography.displayString"
                                ></agpr-meta-data>
                            </div>
                        }
                        <div class="agpr-top-entities-miniProfile-metricContainer">
                            @if (outletEntity.languages?.length > 0) {
                                <div class="agpr-top-entities-miniProfile-infoCard">
                                    <agpr-meta-data
                                        [id]="id"
                                        [type]="attributeTypesEnum.language"
                                        [icon]="'fa-solid fa-language'"
                                        [value]="languagesDisplay"
                                        [tooltip]="languagesDisplayTooltip"
                                        [isMultiline]="true"
                                    ></agpr-meta-data>
                                </div>
                            }
                            @if (outletEntity?.circulations && outletEntity?.circulations.length > 0) {
                                <div class="agpr-profileSection-content">
                                    @for (circulation of outletEntity.circulations; track circulation; let last = $last) {
                                        @if ((circulation.circulationType.enumValue === circulationType.manualValue || circulation.circulationType.enumValue === circulationType.similarWebValue)
                                            && circulation.isSimilarWeb) {
                                            <div
                                                [class.agpr-profileSection-content--inner]="!last"
                                                class="agpr-top-entities-miniProfile-infoCard"
                                            >
                                                <agpr-meta-data
                                                    [id]="id"
                                                    [type]="attributeTypesEnum.audienceReach"
                                                    [icon]="'fa-solid fa-id-badge'"
                                                    [value]="circulation.value"
                                                    [isSimilarWeb]="circulation.isSimilarWeb"
                                                    [tooltip]="'Discover.targeting.sortFields.uniqueVisitors' | localize"
                                                ></agpr-meta-data>
                                            </div>
                                        }
                                    }
                                </div>
                            }
                            @if (outletEntity.domainAuthority) {
                                <div class="agpr-top-entities-miniProfile-infoCard">
                                    <agpr-meta-data
                                        [id]="id"
                                        [type]="attributeTypesEnum.domainAuthority"
                                        [icon]="'fa-solid fa-gauge-simple-high'"
                                        [value]="outletEntity.domainAuthority"
                                        [tooltip]="'Discover.entityProfile.domainAuthority' | localize"
                                    ></agpr-meta-data>
                                </div>
                            }

                        </div>
                    }
                    @if (selectedEntity?.entityType === entityTypes.CONTACT && contactEntity) {
                        @if (selectedEmployment?.jobTitle) {
                            <div class="agpr-top-entities-miniProfile-infoCard">
                                <agpr-meta-data
                                    [id]="id"
                                    [value]="selectedEmployment.jobTitle"
                                    [icon]="'fa-solid fa-briefcase'"
                                    [tooltip]="selectedEmployment.jobTitle"
                                ></agpr-meta-data>
                            </div>
                        }
                        @if (selectedEmployment?.outlet?.name) {
                            <div class="agpr-top-entities-miniProfile-infoCard">
                                <agpr-meta-data
                                    [id]="id"
                                    [value]="selectedEmployment.outlet.name"
                                    [icon]="'fa-solid fa-building'"
                                    [tooltip]="selectedEmployment.outlet.name"
                                ></agpr-meta-data>
                            </div>
                        }
                        @if (selectedEmployment?.outlet?.geography?.displayString) {
                            <div class="agpr-top-entities-miniProfile-infoCard agpr-top-entities-miniProfile-infoCard-geo">
                                <agpr-meta-data
                                    [id]="id"
                                    class="agpr-top-entities-miniProfile-infoCard-geo"
                                    [value]="geographyDisplay"
                                    [icon]="'fa-solid fa-location-dot'"
                                    [tooltip]="geographyDisplay"
                                ></agpr-meta-data>
                            </div>
                        }
                    }
                </ng-template>
                <div class="agpr-top-entities-miniProfile-bio">
                    <h5 class="agpr-top-entities-miniProfile-bio-title"> {{ 'Discover.entityProfile.bio' | localize }} </h5>
                    <agpr-scroll-panel
                        class="agpr-top-entities-miniProfile-bio-content"
                        [style.maxHeight]="height ? (height - headerHeight - titleAndMetadataHeight) + 'px' : null"
                    >
                        <span> {{ selectedEntity.bio }} </span>
                    </agpr-scroll-panel>
                </div>
                @if (canViewProfileDetail) {
                    <div class="agpr-top-entities-miniProfile-viewButtonContainer">
                        <agpr-button
                            class="agpr-top-entities-miniProfile-viewButton"
                            [label]="'Monitor.MAD.topEntities.button.' + entityType"
                            [style]="buttonTypes.tertiary"
                            (click)="openFullEntityProfile()"
                        ></agpr-button>
                    </div>
                }
            } @else {
                <agpr-message
                    class="agpr-top-entities-noContentMessage"
                    [severity]="messageSeverityEnum.noContent"
                >
                    <span>
                        {{ 'Monitor.entityProfile.noAdditionalInfo' | localize }}
                    </span>
                </agpr-message>
            }
        </div>
    </div>
</div>
